import { useState } from 'react'
import { cn } from '@global/utils/tailwind'
import { Checkbox } from './checkbox'

const Title = ({ id, children }) => (
  <Checkbox.Label id={id} className="font-semibold">
    {children}
  </Checkbox.Label>
)

const Summary = ({ children }) => <div className="text-sm">{children}</div>

export const OptionCard = ({ id, children, defaultChecked, onChangeCallback }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked)

  function onChangeHandler(e) {
    setIsChecked(e.target.checked)
    if (onChangeCallback) {
      onChangeCallback(e.target.checked)
    }
  }

  return (
    <section
      className={cn(
        'font-sans flex items-start justify-start w-full max-w-[340px]',
        'bg-cv-blue-50 border border-cv-blue-200',
        'transition-all duration-300',
        isChecked && 'bg-cv-alice-blue-50 border border-cv-alice-blue-200',
        'rounded-lg p-4 gap-4',
      )}
    >
      <Checkbox id={id} checked={isChecked} onChange={onChangeHandler}>
        <div className="flex flex-col gap-4">{children}</div>
      </Checkbox>
    </section>
  )
}

OptionCard.Title = Title
OptionCard.Summary = Summary
